const trips = {
  statuses: {
    new: 'ממתין-לצי',
    approved: 'התקבל',
    canceled: 'נדחה',
  },
  table: {
    floatingActions: {
      tooltips: {
        accept: 'פעולה זו זמינה רק עבור נסיעות במצב "ממתין לצי".',
        decline: 'פעולה זו זמינה רק עבור נסיעות במצב "ממתין לצי".',
      },
    },
    filters: {
      supplier: 'ציים',
    },
    statuses: {
      new: 'ממתין-לצי',
      approved: 'התקבל',
      canceled: 'נדחה',
    },
    headers: {
      supplier: 'ציים',
    },
    cells: {
      supplier: {
        none: 'אין ציים',
      },
      actions: {
        approve: 'קבל',
        remove: 'דחה',
      }
    },
  },
};

export default trips;
